import React from 'react';
import { cn } from '@/lib/utils';
import { LoginBee } from '@/components/brand/login-bee';

/**
 * The bees at work - the sign-in page's motif - wherever the product asks
 * for attention: a banner, the attention band, the corner of an empty state.
 * The comb fills cell by cell as the bee carries cookies home; it stops under
 * prefers-reduced-motion with the comb drawn full. Decorative and inert.
 * Size it by width with className; height follows the 300x230 art.
 */
export function HiveAccent({ className }) {
  return <LoginBee inline className={cn('w-24 shrink-0', className)} />;
}

export default HiveAccent;
